(function () {
  var SEL = '.product-grid__item, .collection-card, .product-recommendations .product-card, [data-template="cart"] .cart-summary';
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('pg-in'); e.target.classList.remove('pg-hide'); io.unobserve(e.target); }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -30px 0px' }) : null;
  function scan(scope) {
    if (!io) return;
    (scope || document).querySelectorAll(SEL).forEach(function (el, i) {
      if (el.dataset.pgSeen || el.closest('.ph-root')) return;
      el.dataset.pgSeen = '1';
      var r = el.getBoundingClientRect();
      if (r.top > window.innerHeight) {
        el.classList.add('pg-hide');
        el.style.transitionDelay = ((i % 4) * 0.07) + 's';
        io.observe(el);
      }
    });
  }
  function bumpCart() {
    document.querySelectorAll('cart-icon, .header-actions__cart-icon, [data-cart-icon]').forEach(function (el) {
      el.classList.remove('pg-bump'); void el.offsetWidth; el.classList.add('pg-bump');
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.add-to-cart-button, .quick-add__button');
    if (!btn || btn.disabled) return;
    btn.classList.remove('pg-pop'); void btn.offsetWidth; btn.classList.add('pg-pop');
  });
  document.addEventListener('cart:update', bumpCart);
  function boot() {
    scan();
    if ('MutationObserver' in window) {
      var t;
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(scan, 120); }).observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();